<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">
              แจ้งย้ายสาขา (หน่วยดำเนินการ)
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          แจ้งย้ายสาขา (หน่วยดำเนินการ)
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/AgenteService">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div
            class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            "
          >
            แจ้งย้ายสาขา (หน่วยดำเนินการ)
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="mt-2 mt-lg-2">
            <ul class="list-group">
              <li class="list-group-item list-group-item-action blue-1">
                <div
                  class="
                    col-12
                    d-flex
                    flex-row flex-wrap
                    justify-content-between
                  "
                >
                  <div class="text-start gary-3 fw-normal font-family fs-5">
                    ระบุตัวแทนที่ต้องการย้ายสาขา<span class="required">*</span>
                  </div>
                  <div class="text-end">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      @click="CheckAll()"
                      v-model="isCheckAll"
                    /><label class="fw-normal font-family fs-5 ps-1"
                      >เลือกทั้งหมด</label
                    >
                  </div>
                </div>
              </li>
              <li
                class="list-group-item list-group-item-action blue-1"
                v-for="(lang, index) in langsdata"
                :key="index"
              >
                <div class="col-12 row">
                  <div class="w-auto">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      :key="index"
                      :value="lang.AGENTCODE"
                      v-model="languages"
                      @change="UpdateCheckall(index)"
                    />
                  </div>
                  <div class="w-auto pd-0">
                    <label class="fw-normal font-family fs-5 ps-1">รหัส {{ lang.AGENTCODE }} {{ lang.PRENAME }} {{ lang.NAME }} {{ lang.SURNAME }}</label>
                  </div>
                </div>
                <Transition>
                  <div class="col-12 row" v-if="lang.SHOWBRANCH">
                    <div class="w-auto"></div>
                    <div class="pd-l">
                      <label class="fw-normal font-family fs-5 ps-1">{{ lang.DESCRIPTION }}</label>
                    </div>
                  </div>
                </Transition>
              </li>
            </ul>
          </div>
          <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              เปลี่ยนเป็น :
            </div>
            <div class="gray-3 fs-5 font-family">
              สาขาใหม่<span class="required">*</span>
            </div>
            <div class="font-family fs-5">
              <v-select
                v-model="ChangeBranch"
                :reduce="(option) => option.value"
                :options="this.ZTB_OFFICE"
                placeholder="กรุณาเลือกสาขาหรือพิมพ์ชื่อสาขา"
              />
            </div>
          </div>
          <div class="pb-3 pb-lg-3">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              วัตถุประสงค์ของการขอย้าย<span class="required">*</span> :
            </div>
            <div class="fs-4 font-family">
              <input
                v-model="MemoChangBranch"
                type="text"
                class="field field__input a-field__input"
                style="border-bottom: 1px solid #d0d0d0"
                autocomplete="off"
              />
            </div>
          </div>
          <div class="col mt-2">
            <button class="btn-CB  border border-0 rounded w-100 font-family" @click="EnterNext()">
              <label class="btn-next">ดำเนินการต่อ</label>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "ManagerBranchView",
  components: {
    Menu,
    LoadingBs5,
  },
  data() {
    return {
      Loading: true,
      isCheckAll: false,
      languages: [],
      langsdata: [],
      ZTB_OFFICE: [],
      ChangeBranch: '',
      MemoChangBranch: '',
    };
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetName?",{ headers: { Authorization: `Bearer ${AuthorizeToken}` }}).then((res) => { 
      if(res.status == 200) {
        this.$store.state.UserName = res.data.NAME + " " + res.data.SURNAME;
        this.Loading = false;

        let params = { AGENTCODE: res.data.AGENTCODE };
        http.get("AgencyERequest/Permission?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then(() => { 
          
        }).catch(() => { 
          console.log("Catch Fond")
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">สำหรับผู้บริหารหน่วยดำเนินการเท่านั้น</label>',
          }).then(() => { 
            this.$router.push("/AgenteService");
          });
        });
      }
      else { 
        this.Loading = false;
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
      }
    }).catch((error) => { 
      this.Loading = false;
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">'+ error.response.data.ErrorMessage +'</label>',
      }).then(() => { 
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
      });
    });

    http.get("AgencyERequest/GetUnderManagerOffice?",{ headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200) {
        res.data.forEach(item => {
          this.langsdata.push({
            AGENTCODE: item.AGENTCODE,
            PRENAME: item.PRENAME,
            NAME: item.NAME,
            SURNAME: item.SURNAME,
            DESCRIPTION: item.DESCRIPTION,
            SHOWBRANCH: false
          });
        });
      }
      else {

      }
    });

    http.get("AgencyERequest/GetOffice", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200) {
        res.data.forEach((item, index) => {
          this.ZTB_OFFICE.push({
            id: index,
            label: item.DESCRIPTION,
            value: item.OFFICE
          });
        });
      }
    });
  },
  methods: {
    CheckAll() {
      this.isCheckAll = !this.isCheckAll;
      this.languages = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.langsdata) {
          this.languages.push(this.langsdata[key].AGENTCODE);
          this.langsdata[key].SHOWBRANCH = true;
        }
      } else {
        for (var key in this.langsdata) {
          this.langsdata[key].SHOWBRANCH = false;
        }
      }
    },
    UpdateCheckall(id) {
      this.langsdata[id].SHOWBRANCH = !this.langsdata[id].SHOWBRANCH;
      if (this.languages.length == this.langsdata.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
    },
    EnterNext() {
      if(this.languages.length <= 0) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุตัวแทนที่ต้องการย้ายสาขา</label>',
        });
      }
      else if(this.ChangeBranch === '' || this.ChangeBranch === null) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุสาขาที่ต้องการย้าย</label>',
        });
      }
      else if(this.MemoChangBranch === '' || this.MemoChangBranch === null) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุวัตถุประสงค์ของการขอย้าย</label>',
        });
      }
      else {
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        this.$store.state.CHANGE_OFFICE.AGENTCODE_CHG = [];
        this.$store.state.PASS_OFFICE.DETAIL = [];

        this.languages.forEach(item => {
          this.langsdata.forEach(data => {
            if(item === data.AGENTCODE) {
              let AGENT_NAME = data.AGENTCODE + " " + data.PRENAME + " " + data.NAME + " " + data.SURNAME;
              let DATA_BEFORE = { 
                AGENT_NAME: AGENT_NAME,
                BARNCH: data.DESCRIPTION
              };
              this.$store.state.PASS_OFFICE.DETAIL.push(DATA_BEFORE);
            }
          });
          //ปั่นข้อมูล INSERT DATABASE
          this.$store.state.CHANGE_OFFICE.AGENTCODE_CHG.push(item);
        });

        let request = {
          AGENTCODE: this.$store.state.CHANGE_OFFICE.AGENTCODE_CHG,
          SUBJOB: this.$store.state.CHANGE_OFFICE.SUBJOB,
        }

        http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => { 
          if(response.status == 200) {
            if(response.data !== '001' && response.data !== '002') { 
              this.ZTB_OFFICE.forEach(item => {
                if(item.value === this.ChangeBranch) {
                  this.$store.state.PASS_OFFICE.OFFICE = item.label;
                }
              });
              this.$store.state.PASS_OFFICE.MEMO = this.MemoChangBranch;

              //ปั่นข้อมูล INSERT DATABASE
              this.$store.state.CHANGE_OFFICE.OFFICE = this.ChangeBranch;
              this.$store.state.CHANGE_OFFICE.CHG_BY = 'UNT';
              this.$store.state.CHANGE_OFFICE.REASON_DTL = this.MemoChangBranch;

              this.$router.push('/FinishManagerBranch');
            }
            else {
              Swal.fire({
                icon: 'error',
                html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
              });

              this.$router.push("/AgenteService");
            }
          }
        }).catch(() => { 
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">สำหรับผู้บริหารหน่วยดำเนินการเท่านั้น</label>',
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.pd-0 {
  padding: 0;
}
.pd-l {
  width: auto;
  padding-left: 16px;
}
.w-auto {
  width: auto;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>